(function() {
  'use strict';

  angular.module('eclipseApp.myAccount').factory('manageDataService', manageDataService);

  manageDataService.$inject = ['$http', '$rootScope', '$window', 'uteLocale', 'uteEndpoint', 'env', 'uuid'];

  function manageDataService($http, $rootScope, $window, uteLocale, uteEndpoint, env, uuid) {
    var manageDataModel = {
      accountId: null,
      subscriptionIds: [],
      manageDataCtnList: [],
      pricePlanDetails: null,
      billingInfo: null
    };

    var service = {
      getAllTopUpsFromGenesis: getAllTopUpsFromGenesis,
      getAllTopUpsFromMS: getAllTopUpsFromMS,
      getAccountInfoFromGenesis: getAccountInfoFromGenesis,
      getBillingInfoFromGenesis: getBillingInfoFromGenesis,
      getDataExtrasFromGenesis: getDataExtrasFromGenesis,
      getJWTforWCOC: getJWTforWCOC,

      setAccountId: setAccountId,
      getAccountId: getAccountId,
      setCTNList: setCTNList,
      getCTNList: getCTNList,
      setBillingInfo: setBillingInfo,
      getBillingInfo: getBillingInfo,

      calculateTotalBonus: calculateTotalBonus,
      calculateTotalOTTAndMDT: calculateTotalOTTAndMDT
    };

    return service;

    function getAccountId() {
      return manageDataModel.accountId;
    }
    function setAccountId(accountId) {
      manageDataModel.accountId = accountId;
    }

    function getCTNList() {
      return manageDataModel.manageDataCtnList;
    }

    function setCTNList(ctnList) {
      manageDataModel.manageDataCtnList = ctnList;
    }

    function getPricePlanDetails() {
      return manageDataModel.pricePlanDetails;
    }

    function setPricePlanDetails(dataUsage) {
      manageDataModel.pricePlanDetails = dataUsage;
    }

    function getBillingInfo() {
      var billingInfo = {};
      billingInfo.cycleEndDate = manageDataModel.billingInfo ? manageDataModel.billingInfo.billCycleEndDate : '';
      billingInfo.nextCycleStartDate = manageDataModel.billingInfo
        ? manageDataModel.billingInfo.nextBillCycleStartDate
        : '';
      return billingInfo;
    }

    function setBillingInfo(billingInfo) {
      manageDataModel.billingInfo = billingInfo;
    }

    function getAllTopUpsFromGenesis(accountId, subscriptionId) {
      return $http({
        method: 'GET',
        url:
          env.genesisApiURL +
          'usage/v2/customer/accounts/' +
          accountId +
          '/services/non-shared/' +
          subscriptionId +
          '/top-ups',
        headers: {
          'x-app-id': getXAppId(),
          brand: 'Fido',
          'x-session-token': getXSessionToken(),
          'If-Modified-Since': null
        },
        transformRequest: function(data, headers) {
          delete headers()['If-Modified-Since'];
        },
        withCredentials: false,
        cache: false
      });
    }

    function getAllTopUpsFromMS(accountId, subscriptionId) {
      return $http({
        method: 'GET',
        url:
          env.msapis.base + 'v1/customer/accounts/' + accountId + '/services/non-shared/' + subscriptionId + '/top-ups',
        headers: {
          Authorization: 'Bearer ' + getXInfoToken(),
          client_id: 'MyAccount',
          correlation_id: uuid.v4()
        },
        withCredentials: false
      });
    }

    function getAccountInfoFromGenesis() {
      return $http({
        method: 'GET',
        url: env.genesisApiURL + 'genesis-agg-svc/v3/profile/' + getProfileId() + '?brand=FIDO',
        headers: {
          'x-app-id': getXAppId(),
          'x-session-token': getXSessionToken(),
          'If-Modified-Since': null
        },
        transformRequest: function(data, headers) {
          delete headers()['If-Modified-Since'];
        },
        withCredentials: false,
        cache: false
      });
    }

    function getBillingInfoFromGenesis(accountId) {
      return $http({
        method: 'GET',
        url: env.genesisApiURL + 'billing-account-svc/v1/accounts/' + accountId + '/billingInfo',
        headers: getHeaders(),
        transformRequest: function(data, headers) {
          delete headers()['If-Modified-Since'];
        },
        withCredentials: false,
        cache: false
      });
    }

    function getDataExtrasFromGenesis(ban, ctn) {
      return $http({
        method: 'POST',
        url: env.genesisApiURL + 'uep/v1/dataExtras',
        headers: {
          'x-app-id': getXAppId(),
          'x-session-token': getXSessionToken(),
          userId: getUserId(),
          profileId: getProfileId()
        },
        data: {
          accountNumber: ban,
          ctn: ctn,
          language: uteLocale.language,
          region: uteLocale.province
        },
        withCredentials: false
      });
    }

    function getJWTforWCOC() {
      var accountId = getWcocTokenData().accountId || $rootScope.userInfo.account_id || null;
      var loginType = getWcocTokenData().loginType || $rootScope.userInfo.loginType || 'email';
      var msisdn = getWcocTokenData().msisdn || $rootScope.userInfo.msisdn || null;
      var profileType = getWcocTokenData().profileType || '1';
      var userId = getUserId();
      var uuid = getProfileId() || $rootScope.userInfo.uuid;

      return $http({
        method: 'POST',
        url: uteEndpoint('v1/wcoc/createjwttoken'),
        data: {
          language: uteLocale.language,
          applicationId: 'Fido.ca',
          accountId: accountId,
          loginType: loginType,
          msisdn: msisdn,
          profileType: profileType,
          userId: userId,
          uuid: uuid
        }
      });
    }

    function getHeaders() {
      return {
        'x-app-id': getXAppId(),
        'x-session-token': getXSessionToken(),
        userId: getUserId(),
        profileId: getProfileId(),
        'If-Modified-Since': null
      };
    }

    function getXAppId() {
      return 'FIDOWEB';
    }

    function getXInfoToken() {
      return $window.sessionStorage.getItem('x_info_token') || $window.localStorage.getItem('x_info_token');
    }

    function getXSessionToken() {
      return $window.localStorage.getItem('x_session_token');
    }

    function getProfileId() {
      var eld = getEasyLoginData();
      if (eld) {
        return JSON.parse(eld).uuid;
      }
    }

    function getUserId() {
      var eld = getEasyLoginData();
      if (eld) {
        return JSON.parse(eld).userID;
      }
    }

    function getEasyLoginData() {
      return $window.sessionStorage.getItem('easyLoginDataJanrain');
    }

    function getWcocTokenData() {
      return JSON.parse($window.sessionStorage.getItem('WCOCCreateTokenData'));
    }

    function calculateTotalBonus(dataBonus) {
      var afterConversionToMB = _.forEach(dataBonus, function(v, i) {
        v.data = convertToMB(v.data, v.uom);
        v.uom = 'MB';
      });
      var totalDataFromBonusInMB = 0;
      _.forEach(afterConversionToMB, function(bonus, i) {
        totalDataFromBonusInMB += bonus.data * bonus.quantity;
      });
      return totalDataFromBonusInMB;
    }

    function calculateTotalOTTAndMDT(topupList) {
      var postConversionToMB = _.forEach(topupList, function(v, i) {
        v.size.value = convertToMB(v.size.value, v.size.unit);
        v.size.unit = 'MB';
      });
      var totalDataInMB = 0;
      _.forEach(postConversionToMB, function(m, i) {
        totalDataInMB += m.size.value;
      });
      return totalDataInMB;
    }

    function convertToMB(data, unit) {
      if (isNaN(parseFloat(data)) || !isFinite(data)) {
        return null;
      }

      var units = ['kb', 'mb', 'gb', 'tb', 'pb'];
      var index = units.indexOf(unit.toLowerCase());

      if (index !== -1) {
        switch (index) {
          case 0:
            return data / 1024; // convert KB to MB
          case 1:
            return data; // return MB as is
          case 2:
            return data * 1024; // convert GB to MB
          case 3:
            return data * Math.pow(1024, 2); // convert TB to MB
          case 4:
            return data * Math.pow(1024, 3); // convert PB to MB
          default:
            return null;
        }
      } else {
        return null;
      }
    }
  }
})();
